export const api_pokemon = "https://pokeapi.co/api/v2/pokemon/";
